import { render, staticRenderFns } from "./EmployeeBranchDelete.vue?vue&type=template&id=479b8038&"
import script from "./EmployeeBranchDelete.vue?vue&type=script&lang=js&"
export * from "./EmployeeBranchDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports